import { render, staticRenderFns } from "./ChooseOfWheels.vue?vue&type=template&id=8a6204fc&scoped=true&"
import script from "./ChooseOfWheels.vue?vue&type=script&lang=js&"
export * from "./ChooseOfWheels.vue?vue&type=script&lang=js&"
import style0 from "./ChooseOfWheels.vue?vue&type=style&index=0&id=8a6204fc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a6204fc",
  null
  
)

/* custom blocks */
import block0 from "../../assets/litie.png?vue&type=custom&index=0&blockType=img&issuerPath=%2Fhome%2Fcashbox%2Ffrontend%2Fsrc%2Fcomponents%2Fcalcs%2FChooseOfWheels.vue&height=40&width=40"
if (typeof block0 === 'function') block0(component)

export default component.exports